module.exports = __webpack_public_path__ + "media/src/images/zu_teaching_uni_page2-2a9031378c8d3275d1e95af1ae36d59d.gif";